import { useState } from 'react';
import {
  Button,
  useRecordContext,
  useUpdate,
  useNotify,
  useRefresh,
} from 'react-admin';
import { Block as BlockIcon, CheckCircle as UnblockIcon } from '@mui/icons-material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button as MuiButton,
} from '@mui/material';

export const BanButton = () => {
  const record = useRecordContext();
  const [update, { isLoading }] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!record) return null;

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleConfirm = () => {
    const newStatus = !record.is_blacklisted;

    update(
      'users',
      {
        id: record.id,
        data: { is_blacklisted: newStatus },
        previousData: record,
      },
      {
        onSuccess: () => {
          notify(newStatus ? 'User banned successfully' : 'User unbanned successfully', {
            type: 'success',
          });
          refresh();
          handleCloseDialog();
        },
        onError: (error: any) => {
          notify(`Error updating user: ${error.message}`, { type: 'error' });
          handleCloseDialog();
        },
      }
    );
  };

  return (
    <>
      <Button
        label={record.is_blacklisted ? 'Unban' : 'Ban'}
        onClick={handleOpenDialog}
        disabled={isLoading}
      >
        {record.is_blacklisted ? <UnblockIcon /> : <BlockIcon />}
      </Button>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="ban-dialog-title"
        aria-describedby="ban-dialog-description"
      >
        <DialogTitle id="ban-dialog-title">
          {record.is_blacklisted ? 'Unban User' : 'Ban User'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="ban-dialog-description">
            {record.is_blacklisted ? (
              <>
                Are you sure you want to unban{' '}
                <strong>
                  {record.username ? `@${record.username}` : record.first_name}
                </strong>
                ? They will be able to participate in events and place bets again.
              </>
            ) : (
              <>
                Are you sure you want to ban{' '}
                <strong>
                  {record.username ? `@${record.username}` : record.first_name}
                </strong>
                ? They will not be able to participate in events or place bets.
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={handleCloseDialog} disabled={isLoading}>
            Cancel
          </MuiButton>
          <MuiButton
            onClick={handleConfirm}
            color={record.is_blacklisted ? 'primary' : 'error'}
            variant="contained"
            disabled={isLoading}
            autoFocus
          >
            {record.is_blacklisted ? 'Unban' : 'Ban'}
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
